// extracted by mini-css-extract-plugin
module.exports = {"formBtn":"FormBtn_formBtn__5vYkQ","formBtn_disabled":"FormBtn_formBtn_disabled__tVSfs","formBtn__txt":"FormBtn_formBtn__txt__GKsPT"};